import { Box } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";

export const GBox = ({ children }: { children?: any }) => {
	return (
		<Box
			sx={{
				gap: "20px",
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
			}}>
			{children}
		</Box>
	);
};
export const HeadBlock = ({ children, hoverable, onClick }: { children?: any; hoverable?: boolean; onClick?: () => void }) => {
	return (
		<Typo
			block
			variant="caption"
			bold
			sx={{
				backgroundColor: "#cdd2d8",
				padding: "14px",
				borderRadius: "6px",
				color: "#3b4a5d",
				opacity: 1,
				cursor: hoverable ? "pointer" : "default",
				transition: hoverable ? "background-color .2s" : undefined,
				"&:hover": hoverable ? { backgroundColor: "#b8bfc8" } : (undefined as any),
			}}
			onClick={onClick}>
			{children}
		</Typo>
	);
};
